import { HttpParams } from '@angular/common/http';

export function getQueryParams<T extends object>(data: T): HttpParams {
  let params = new HttpParams();
  for (const key of Object.keys(data) as (keyof T)[]) {
    const value = data[key];
    if (value || value === 0 || typeof value === 'boolean') {
      params = params.append(key as string, value as string | number | boolean);
    }
  }
  return params;
}
